module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/file-text-o-125a8f5de8b3180db07a11ad81f24154.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/file-text-o.svg
// module id = lGvE
// module chunks = 24